import { createSlice, PayloadAction } from '@reduxjs/toolkit';
 
interface CartList {
    isLoading: boolean;
    error: string | null;
    cartList: any| null;
    paymentCompleted: boolean;
}

const initialState: CartList = {
    cartList: null,
    isLoading: false,
    error: null,
    paymentCompleted: false,
};

const CartListSlice = createSlice({
    name: 'cartlist',
    initialState,
    reducers: {
        setCartList: (state: CartList, action: PayloadAction<CartList>) => {
            state.cartList = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setloading: (state: CartList, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        seterror: (state: CartList, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetCartList: (state: CartList) => { 
            state.cartList = [];
            state.isLoading = false;
            state.error = null;
            state.paymentCompleted = true;
        },
        clearPaymentFlag: (state: CartList) => {
            state.paymentCompleted = false;
        },
    },
});

export const { setCartList, setloading, seterror, resetCartList,clearPaymentFlag  } = CartListSlice.actions;

export default CartListSlice.reducer;